import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { catchError, map } from 'rxjs';
import { environment } from '@environments/environment';

interface LongAccessTokenResponse {
    code: number;
    message: string;
    data: {
        access_token: string;
        token_type: string;
        expires_in: number;
    };
}

@Injectable({
    providedIn: 'root',
})
export class FacebookSdkApiService extends BaseApiService {
    exchangeCodeForToken(code: string) {
        return this.post('/form/exchange-token', { code }, { baseUrl: environment.ip_purchase }).pipe(
            map((response: any) => {
                if (response.data) {
                    return response.data.access_token;
                } else {
                    throw new Error('Invalid response from token exchange');
                }
            }),
            catchError((error) => {
                console.error('Error exchanging code for token:', error);
                throw error;
            }),
        );
    }

    getLongAccessToken(shortAccessToken: string) {
        return this.post<LongAccessTokenResponse>(
            '/form/login-sdk-long-access-token',
            { short_access_token: shortAccessToken },
            { baseUrl: environment.ip_purchase },
        ).pipe(
            map((response) => response.data.access_token),
            catchError((error) => {
                console.error('Error getting long access token:', error);
                throw error;
            }),
        );
    }
}
